export default __webpack_public_path__ + "static/media/Dropbox Icon.b5210674.svg";